//Margin conventions
		var margin = {top: 5, right: 10, bottom: 20, left: 42};
		var widther = d3.select(".gia-chart").node().clientWidth;
		var width = widther - margin.left - margin.right,
		    height = 280 - margin.top - margin.bottom;

		//Appends the svg to the chart-container div
		var svg = d3.select(".gia-chart").append("svg")
			.attr("width", width + margin.left + margin.right)
			.attr("height", height + margin.top + margin.bottom)
			.append("g")
			.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

		//Creates the xScale 
			var xScale = d3.scale.ordinal()
				.rangeRoundBands([0, width], .15);

			//Creates the yScale
			var yScale = d3.scale.linear()
				.range([height, 0]);

			//Defines the y axis styles
			var yAxis = d3.svg.axis()
				.scale(yScale)
				.tickSize(-width)
				.tickPadding(8)
				.tickFormat(function(d) { return d + "%"; })
				.orient("left"); 

		//Loads the data
		d3.csv("data/homcidePct.csv", ready);

		function ready(err, data) {
			if (err) throw "error loading data";
			console.log(data)

			//FORMAT data
			data.forEach(function(d) {
				d.change = +d.change;
			});

		  	//Sets min and max on xScale
		  	var xMin = d3.min(data, function(d) { return d.date;});
		  	var xMax = d3.max(data, function(d) { return d.date;});
		  	var yMin = d3.min(data, function(d) { return d.change;});
		  	var yMax = d3.max(data, function(d) { return d.change;});

  			//Sets scale domains
  			xScale.domain(data.map(function(d) { return d.date; }));
  			yScale.domain([d3.min(data,function(d){return d.change}), d3.max(data, function(d) { return d.change; })]);
			
  			//Defines the x axis styles
		  	var xAxis = d3.svg.axis()
		    	.scale(xScale)
		    	.tickSize(height)
		    	.tickPadding(8)
		    	.tickValues(xScale.domain().filter(function(d, i) { return !(i % 8); }))
		    	.orient("bottom"); 

  			//Appends the y axis
			var yAxisGroup = svg.append("g")
				.attr("class", "y axis")
				.call(yAxis)
    			.selectAll("g")
    			.classed("g-baseline", function(d) { return d == 0 });

  			//Binds the data to the bars      
  			var bar = svg.selectAll(".bar")
  			  	.data(data)
  			  	.enter()
  			  	.append("rect")
  			  	.attr("class", "bar")
  			  	.attr("x", function(d) { return xScale(d.date); })
  			  	.attr("width", xScale.rangeBand())
  			  	.attr("y", function(d) { return yScale(Math.max(0, d.change)); })
				.attr("height", function(d) { return Math.abs(yScale(d.change) - yScale(0)); })

		
			//Appends the x axis		
			var xAxisGroup = svg.append("g")
				.attr("class", "x axis")
				.call(xAxis);

			var baseline = svg.append("line")
				.attr("x2", function(d) {
					return width
				})
				.attr("class", "added line")
				.attr("y1", 149)
				.attr("y2", 149)
				.attr("stroke-width", 1)
	            .attr("stroke", "#333333");
					

  			//RESPONSIVENESS
  			d3.select(window).on("resize", resized);
  			
  			function resized() {

			//new margin
    			var newMargin = {top: 5, right: 10, bottom: 20, left: 42};

    			var newWidther = d3.select(".gia-chart").node().clientWidth;

    			var newWidth = newWidther - newMargin.left - newMargin.right;

    			//Change the width of the svg
    			d3.select("svg")
      				.attr("width", newWidth + newMargin.left + newMargin.right);

    			//Change the xScale
    			xScale
    			  .rangeRoundBands([0, newWidth], .15);

    			//Update the bars
    			d3.selectAll("rect")
    			  .attr("x", function(d) { return xScale(d.date); })
    			  .attr("width", xScale.rangeBand())

    			//Update line
    			d3.selectAll("line")
    			  .attr("x2", function(d) {
					return newWidth
				})


    			//Updates xAxis
    			d3.selectAll(".x.axis")
         			.call(xAxis);   

    			//Updates ticks
    			xAxis
     			 .scale(xScale)

    			//Updates yAxis  
    			d3.selectAll(".y.axis")
      				.call(yAxis); 

    			yAxis
      				.tickSize(-newWidth);
  				};
		}


